import ProductCardLoader from './ProductCardLoader';

export default ProductCardLoader;
